import { actionTypes } from "./actions";

export const initialState = {
  controlSytems: [],
  controlSytemsloading: false
};

// ===========================|| COMMON REDUCER ||=========================== //

const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONTROL_SYSTEM_PENDING:
      return {
        ...state,
        controlSytemsloading: true,
      };
      case actionTypes.CONTROL_SYSTEM_RECEIVED:
      return {
        ...state,
        controlSytems: action.payload.map((dt, index)=>({...dt, id:index})),
        controlSytemsloading: false,
      };
      case actionTypes.CONTROL_SYSTEM_FAILED:
      return {
        ...state,
        isControlSystemFail: false,
        controlSytemsloading: false
      };
    default:
      return state;
  }
};

export default countryReducer;
